<template>
  <fragment>
    <app-header v-bind="{ title }">
      <template #actions>
        <button class="btn btn-primary" @click="sync" :disabled="syncing">
          <i class="fal fa-sync fa-fw"/>
          Sync Project
        </button>
      </template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'support.project-dependencies.single' }"
        active-class=""
        :class="{
          active: $route.name === 'support.project-dependencies.single',
        }"
      >
        <a class="nav-link">Dependencies</a>
      </router-link>
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'support.project-dependencies.single.vulnerabilities' }"
      >
        <a class="nav-link">Vulnerabilities</a>
      </router-link>
    </ul>

    <div class="container container-fluid my-4">
      <router-view v-if="application.id" />
    </div>
  </fragment>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { notify } from '@/utils'

export default {
  props: ['applicationId'],

  data () {
    return {
      syncing: false
    }
  },

  computed: {
    ...mapState('applications', {
      application: 'single'
    }),

    title () {
      if (this.application && this.application.client) {
        return this.application.client.company
      }

      return this.application.name
    }
  },

  async created () {
    await this.getApplication(this.applicationId)
  },

  beforeDestroy () {
    this.resetApplication()
  },

  methods: {
    ...mapActions('applications', {
      getApplication: 'getSingle',
      resetApplication: 'resetSingle',
      syncApplication: 'syncApplication'
    }),

    async sync () {
      try {
        this.syncing = true

        await this.syncApplication()

        notify.success('Project is now syncing, this may take a few minutes.')
      } catch (error) {
        notify.error('Something went wrong when syncing the project.')
      } finally {
        this.syncing = false
      }
    }
  }
}
</script>
